import { User } from 'firebase/auth'
import { get, onDisconnect, onValue, remove, set, update } from 'firebase/database'
import noop from 'lodash/noop'

import { gamesRef, playersRef, presenceRef } from './database'
import { DatabaseGame, Player } from './types'

export const upsertUserInfo = async ({ uid, photoURL, displayName, email }: User) => {
  await update(playersRef(uid), {
    avatar: photoURL,
    displayName,
    email,
  })
}

export const updateUserNickname = async (uid: string, nickname: string) => {
  await update(playersRef(uid), { nickname })
}

export const subscribeToUserInfo = (uid?: string, cb?: (player: Player) => void) => {
  if (!uid) return noop

  return onValue(playersRef(uid), snapshot => {
    const player = snapshot.val()
    cb?.(player)
  })
}

export const getPlayerGames = async (playerId: string) => {
  const playerGames = (await get(playersRef(`${playerId}/games/all`))).val() as Object

  const games = await Promise.all(
    Object.keys(playerGames).map(async gameId => {
      return (await get(gamesRef(`all/${gameId}`))).val() as DatabaseGame
    })
  )

  return games
}

export const setPlayerConnection = (uid: string) => {
  const presenceCon = playersRef(`${uid}/online`)

  onValue(presenceRef, snap => {
    if (snap.val()) {
      set(presenceCon, true)
      onDisconnect(presenceCon).set(false)
    } else {
      remove(presenceCon)
    }
  })
}
